module.exports = __webpack_public_path__ + "static/media/ic-direct-debit-blue.e3c60268.svg";